<template>
    <div class="row">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title">Products</h3>
            </div>
            <table class="table table-bordered table-striped table-condensed">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>Images</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Price</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(product, index) in products">
                        <td class="row-actions-2-btn">

                            <button @click="edit(product)" class="btn btn-primary"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button>
                            <button @click="remove(product.id)" class="btn btn-danger"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></button>
                        </td>
                        <td>
                            <template v-if="product.images.length">
                                <img :src="product.images[0].thumb_url" :alt="product.images[0].filename">
                            </template>
                        </td>
                        <td>{{ product.name }}</td>
                        <td>{{ product.description }}</td>
                        <td>{{ product.price | currency }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


</template>
<script>
    export default {
        data: function () {
            return {
                products: []
            }
        },

        mounted() {
            this.getProducts();
        },

        methods: {
            getProducts() {
                axios.get('/api/v1/products').then((response) => {
                    this.products = response.data;
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading club products.', type: 'error'});
                });
            },

            remove(id) {
                axios.delete(`/api/v1/products/${id}`)
                    .then(response => {
                        this.getProducts();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem removing the product.', type: 'error'});
                    });
            },

            edit(product) {
                this.$emit('edit', product);
            }
        }
    }
</script>
